var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3375 3.12489C4.33734 3.45641 4.20548 3.77429 3.97094 4.00859C3.73641 4.2429 3.4184 4.37443 3.08688 4.37427C2.75536 4.3741 2.43748 4.24225 2.20318 4.00771C1.96887 3.77317 1.83734 3.45516 1.8375 3.12364C1.83767 2.79212 1.96952 2.47425 2.20406 2.23994C2.4386 2.00564 2.75661 1.8741 3.08813 1.87427C3.41965 1.87443 3.73752 2.00629 3.97183 2.24083C4.20613 2.47536 4.33767 2.79337 4.3375 3.12489ZM4.375 5.29989H1.875V13.1249H4.375V5.29989ZM8.325 5.29989H5.8375V13.1249H8.3V9.01864C8.3 6.73114 11.2813 6.51864 11.2813 9.01864V13.1249H13.75V8.16864C13.75 4.31239 9.3375 4.45614 8.3 6.34989L8.325 5.29989Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.65943d93.svg";
export { ForwardRef as ReactComponent };